import { createSelector } from '@reduxjs/toolkit';
export const usersReducer = (state) => state.users;
export const usersSelector = createSelector(usersReducer, (reducer) => {
    return reducer.data;
});
export const officeUsersSelector = (officeId) => createSelector(usersSelector, (users) => {
    return users.filter((user) => user.parent === officeId);
});
